import script from "./UserCo2Quiz.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserCo2Quiz.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__